import { RootState } from '../../../../../bll/store/store';

export const adminMailingFormValuesSelector = (state: RootState) => state.adminMailing.form;
export const adminMailingModalSelector = (state: RootState) => state.adminMailing.modal;
